<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="secondary"
        v-bind="attrs"
        v-on="on"
      >
        Movie: <span v-if="budgetDocument">{{ budgetDocument.name }}</span>
        <v-icon>mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="budgetDocument in budgetDocuments"
        :key="budgetDocument.id"
        @click="change(budgetDocument)"
      >
        <v-list-item-title>{{ budgetDocument.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  name: 'BudgetSwitcher',
  computed: {
    ...mapState('app', ['budgetDocument']),
    ...mapState('budgetDocuments', ['budgetDocuments']),
  },
  methods: {
    ...mapActions('budgetDocuments', ['LOAD_budgetDocuments']),
    ...mapMutations('app', ['SET_budgetDocument']),
    change(budgetDocument) {
      this.SET_budgetDocument(budgetDocument);
      this.$nextTick(() => {
        this.$root.$emit('app:changedBudgetDocumentId', budgetDocument);
        this.$router.push('/');
      });
    },
  },
  async created() {
    await this.LOAD_budgetDocuments();
    this.$root.$on('auth:login', () => {
      this.LOAD_budgetDocuments();
    });
  },
};
</script>
<docs>
# LocaleSwitcher example

'''js
<LocaleSwitcher v-model="locale" />
'''
</docs>
